// extracted by mini-css-extract-plugin
export default {"image":"Home_image__Y45q+"};